import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_get_dock_appointment_by_shipmentIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentId: number }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, ItemEntityId?: number, ItemEntityType?: string, DockAppointment?: { LookupCode?: string, ScheduledArrival?: string, StatusId?: number, TypeId?: number, AssignedLocation?: { Id?: number, Name?: string, ShortName?: string }, ScheduledLocation?: { Id?: number, Name?: string, ShortName?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointment_by_shipmentId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, ItemEntityId?: number, ItemEntityType?: string, DockAppointment?: { LookupCode?: string, ScheduledArrival?: string, StatusId?: number, TypeId?: number, AssignedLocation?: { Id?: number, Name?: string, ShortName?: string }, ScheduledLocation?: { Id?: number, Name?: string, ShortName?: string } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointment_by_shipmentId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, ItemEntityId?: number, ItemEntityType?: string, DockAppointment?: { LookupCode?: string, ScheduledArrival?: string, StatusId?: number, TypeId?: number, AssignedLocation?: { Id?: number, Name?: string, ShortName?: string }, ScheduledLocation?: { Id?: number, Name?: string, ShortName?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointment_by_shipmentId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipmentId: number    }) {
        if(isNil(inParams.shipmentId)) {
          return true; 
        }
      return false;
    }
}
